import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ProviderContext, DropdownContext } from '../Context';

export const DropdownConsumer = ({ children, model, ...props }) => {
  const { dropdownState, setDropdownState, ...values } = useContext(
    ProviderContext
  );

  if (!dropdownState) {
    throw new Error(
      '<Dropdown.Consumer> needs to be wrapped in a <Dropdown.Provider>'
    );
  }

  const isActive = dropdownState.model === model;

  const openDropdown = () => {
    setDropdownState(prevState => {
      return prevState.model !== model ? { model } : prevState;
    });
  };

  const closeDropdown = () => {
    setDropdownState(prevState => {
      return prevState.model === model ? {} : prevState;
    });
  };

  return (
    <DropdownContext.Provider
      {...props}
      value={{
        ...values,
        dropdownState,
        setDropdownState,
        model,
      }}
    >
      {children({ isActive, openDropdown, closeDropdown })}
    </DropdownContext.Provider>
  );
};

DropdownConsumer.propTypes = {
  children: PropTypes.func.isRequired,
  model: PropTypes.string.isRequired,
};
